import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import atlas from 'azure-maps-control';
import axios from 'axios';
import { MdArrowBackIosNew } from "react-icons/md";
import { fetchUserDetails } from '../../Services/userService.js';
import { fetchEmpDetails } from '../../Services/ManagerService.jsx';
import VerifyAlert from '../MyWorklist/VerifyAlert';
import FadeLoader from "react-spinners/FadeLoader";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from 'react-toastify';
import { getApprovalMetadata, resolvePropertyStatus } from '../myproporties/propertyStatus.js';

const ReviewAndConfirm = (props) => {
    const { overrides, handleReview, areasMarked, addressvalue, accountinfo, EmailId, latitude, longitude, toggleCondition, defaultaddress, timeValues, selectedValue, streetName, isSalespersonloggedin, myworklistredirect, isautoSave, parkinglotId, events, userData, selecetedAddress, SelectedBankDetailID, region, areaMarkedStatus, roboTaxiLimit, nickNameStatus, ...rest } = props;
    const hostPath = process.env.REACT_APP_API_BASE_URL;
    const hostHeader = process.env.REACT_APP_CUSTOM_HEADER;
    const [searchedLocation, setsearchedLocation] = useState('')
    const [City, setCity] = useState('')
    const [State, setState] = useState('')
    const [ZipCode, setZip] = useState('')
    const [BankDetails, setBankDetails] = useState({})
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [isPopupVisible, setPopupVisible] = useState(false);
    const [loader, setLoader] = useState(false);
    const navigate = useNavigate();
    const [, setParkinglotId] = useState(null);
    const isDenyFlow = props.isDenyFlow;



    const [areaMarkedError, setAreaMarkedError] = useState({});
    var map;
    useEffect(() => {
        (addressvalue.length !== 0)
            ? setsearchedLocation(addressvalue)
            : setsearchedLocation((defaultaddress || '').trim());
        setBankDetails(accountinfo);

        const lot = props.parkinglotObj;
        const mapAddress = addressvalue.length !== 0
            ? selecetedAddress?.find((item) => item.freeformAddress === addressvalue)
            : null;

        // Prefer newly searched Azure Maps address; otherwise keep existing property
        // address fields. Never overwrite with the logged-in user's profile address
        // when editing an existing property.
        if (mapAddress) {
            setCity(mapAddress.municipality);
            setState(mapAddress.countrySubdivisionName);
            setZip(mapAddress.postalCode);
        } else if (lot?.city || lot?.City || lot?.state || lot?.State || lot?.zipcode || lot?.Zipcode) {
            setCity(lot?.city ?? lot?.City ?? '');
            setState(lot?.state ?? lot?.State ?? '');
            setZip(lot?.zipcode ?? lot?.Zipcode ?? '');
        } else {
            setCity(userData?.cityId);
            setState(userData?.stateId);
            setZip(userData?.zipcode);
        }
    }, [accountinfo, defaultaddress, addressvalue, selecetedAddress, userData, props.parkinglotObj]);
    useEffect(() => {
        MapDetails();

    }, []);

    const getMarkerColor = (markerData, groups) => {
        if (markerData?.Name === "PSL - Parking Space Location" && markerData?.groupName) {
            const group = groups?.find(g => g.name === markerData.groupName);
            if (group) {
                console.log(`PSL ${markerData.pslName}: Group=${markerData.groupName}, Color=${group.color}`);
                return group.color;
            }
        }

       
         const colorMap = {
            "PSL - Parking Space Location": "#006400", 
			"PKE - Parking Entrance": "#f48506bc", 
			"PKX - Parking Exit": "#bdf407",
			"PUE - Pick Up Entrance": "#FFD700",
			"PUL - Pick Up Location": "rgba(255, 0, 0, 0.66)",
			"PUX - Pick Up Exit": "#f40bae66", 
			"DOE - Drop Off Entrance": "#a305f3", 
			"DOL - Drop Off Location": "#5b08f6b6", 
			"DOX - Drop Off Exit": "#0bbaef",        
        };

        return colorMap[markerData?.Name] || "#000000";
    };

    function MapDetails() {
        map = new atlas.Map('myMap', {
            center: [longitude || -122.18402494821507, latitude || 47.61373420362662],
            zoom: 18,
            language: 'en-US',
            style: 'satellite',
            view: 'Auto',
            authOptions: {
                authType: 'subscriptionKey',
                subscriptionKey: 'EN5vcaicwC78zKi3M3980VVB1m7DuuN0vKaDMtYdjBg7daKhx3OTJQQJ99AHAC8vTIngVrqvAAAgAZMPLtXG'
            }
        });

        const zoomControl = new atlas.control.ZoomControl();
        map.controls.add(zoomControl, { position: 'bottom-right' });

        const myCustomJson = areasMarked;

        map.events.add('ready', function () {
            // Blue-pin for searched location
            if (latitude && longitude) {
                const img = document.createElement('img');
                img.src = '/icons/blue-pin.png';
                img.style.width = '80px';
                img.style.height = '130px';
                img.style.objectFit = 'contain';
                img.style.cursor = 'pointer';

                const bluePinMarker = new atlas.HtmlMarker({
                    htmlContent: img,
                    position: [longitude, latitude],
                    anchor: 'bottom'
                });

                map.markers.add(bluePinMarker);
            }

            // Add other markers
            if (myCustomJson.length > 0) {
                for (let i = 0; i < myCustomJson.length; i++) {
                    const markerData = myCustomJson[i];
                    const lat = parseFloat(markerData?.Coordinates?.Latitude?.toFixed(6));
                    const lon = parseFloat(markerData?.Coordinates?.Longitude?.toFixed(6));

                    // Skip if it's the same as searched location
                    if (lat === parseFloat(latitude?.toFixed?.(6)) && lon === parseFloat(longitude?.toFixed?.(6))) {
                        continue;
                    }

                    const position = new atlas.data.Position(lon, lat);
                    const nameSubstring = markerData?.Name?.substring(0, 3);
                    const vehicleSize = markerData?.VehicleSpotSize || "";

                    // ✅ Get color using the helper function with groups
                    const backgroundColor = getMarkerColor(markerData, props.groups);

                    // Calculate text color based on background
                    const isColorDark = (color) => {
                        const hex = color?.replace("#", "");
                        const r = parseInt(hex?.substring(0, 2), 16);
                        const g = parseInt(hex?.substring(2, 4), 16);
                        const b = parseInt(hex?.substring(4, 6), 16);
                        return ((r * 299 + g * 587 + b * 114) / 1000) < 128;
                    };

                    const textColor = isColorDark(backgroundColor) ? "white" : "black";

                    const markerHTML = `
  <div style="position: relative; width: 35px; height: 80px; display: flex; flex-direction: column; align-items: center;">
    
    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="60" viewBox="0 0 24 36" fill="${backgroundColor}">
      <path d="M12 0C5.383 0 0 5.383 0 12c0 7.188 10.83 22.812 10.83 22.812C11.147 34.81 12 34.365 12 34.365S12.853 34.81 13.17 34.812C13.17 34.812 24 19.188 24 12C24 5.383 18.617 0 12 0z"/>
    </svg>
    <div style="
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: ${textColor};
      font-size: 8px;
      font-weight: bold;
    ">
      ${nameSubstring}
    </div>
    <div style="margin-top: -4px; font-size: 10px; font-weight: bold; color: black; background: white; padding: 2px 4px; border-radius: 3px; text-align: center;">
      ${markerData?.pslName || ""}
    </div>
  </div>`;

                    const marker = new atlas.HtmlMarker({
                        htmlContent: markerHTML,
                        position: position,
                        anchor: 'bottom'
                    });

                    map.markers.add(marker);
                }
            }
        });
    }

    const backButtonClick = () => {
        handleReview(false);
        props.backToBankdetails()
        toggleCondition('4 of 5 - Enter Bank Details')
        toggleCondition('5 of 5 - Review and Confirm')
    }
    const selectedRoboTaxiPslNames = new Set(
        (props.roboTaxiSpotsName || []).filter(Boolean)
    );

    const CoardinateDetails = areasMarked.map(item => {
        const isSelectedRoboTaxiPSL =
            props?.RoboTaxis &&
            item.Name === "PSL - Parking Space Location" &&
            selectedRoboTaxiPslNames.has(item?.pslName);

        return {
            Latitude: item.Coordinates.Latitude.toString(),
            Longitude: item.Coordinates.Longitude.toString(),
            Title: item.Coordinates?.Title || item.Name,
            pslName: item?.pslName || "",
            groupName: item?.groupName || "Default", // ✅ MUST be 'groupName' (camelCase)
            ID: item.id.toString(),
            VechileSpotSize: item.Coordinates.Title === "PSL - Parking Space Location" ? (item?.VehicleSpotSize || '') : '',
            RobotaxiSessionStatus: isSelectedRoboTaxiPSL ? "Avilable" : null,
            RobotaxiSelectStatus: isSelectedRoboTaxiPSL,
            ScheduleAvailability: item.ScheduleAvailability || "",
        };
    });

    const Scheduleavailability = events;
    useEffect(() => {
        if (areaMarkedError?.PSLMark && areaMarkedError.PSLMark.length > 0) {
            if (!toast.isActive("areaMarkedError")) {
                toast.error(areaMarkedError.PSLMark, {
                    toastId: "areaMarkedError",
                    position: "top-right",
                    style: {
                        maxWidth: "100%",
                        wordWrap: "break-word",
                        whiteSpace: "normal",
                        textAlign: "center",
                    },
                });
            }
        } else {
            toast.dismiss("areaMarkedError");
        }


    }, [areaMarkedError]);


    const validateFields = () => {
        let error = {};
        const validateField = (field, value, invalidMessage) => {
            if (!value) {
                error[field] = invalidMessage;
            }
        };
        const hasParkingSpaceLocation = props.areasMarked?.some(area => area?.Name === 'PSL - Parking Space Location');

        validateField("PSLMark", hasParkingSpaceLocation, "Please Mark at least one Parking Space");

        if (Object.keys(error).length > 0) {
            setAreaMarkedError(error);
            return false;
        }
        setAreaMarkedError({});
        return true;
    };


    const groupSchedules = (() => {
        const map = {};

        events
            .filter(e => e.isMaster === true)
            .forEach(evt => {
                const groupName = evt.groupName || "Default";
                if (!map[groupName]) map[groupName] = [];

                const groupPSLs = (areasMarked || [])
                    .filter(a => (a.groupName || "Default") === groupName)
                    .map((a, i) => ({
                        id: Number(a.id),
                        pslName: a.pslName || `PSL${i + 1}`
                    }));

                map[groupName].push({
                    // id: evt.recurrenceId || evt.id,
                    id: evt.recurrenceId || evt.id,
                    title: evt.title,
                    allDay: evt.allDay || false,

                    // 🔹 RECURRENCE FIELDS (IMPORTANT)
                    recurrence: evt.recurrence || null,
                    customRecurrenceType: evt.customRecurrenceType || null,
                    customRecurrenceCount: evt.customRecurrenceCount || 1,
                    selectedDays: evt.selectedDays || [],

                    // 🔹 DATE FIELDS
                    start: evt.start,
                    end: evt.end,
                    endType: evt.endType,
                    endDateOn: evt.endDateOn,
                    endAfter: evt.endAfter || null,

                    // 🔹 META
                    recurrenceSummary: evt.recurrenceSummary || "",
                    isHoliday: evt.isHoliday || false,
                    recurrenceId: evt.recurrenceId || evt.id,

                    assignedPSLs: groupPSLs,
                    isMaster: true,
                    isActive: false
                });
            });

        return Object.keys(map).map(groupName => ({
            groupName,
            schedules: map[groupName]
        }));
    })();
    const handleButtonClick = async (e) => {
        setLoader(true);
        e.preventDefault();

        if (!validateFields()) {
            setLoader(false);
            return;
        }

        setIsButtonDisabled(true);

        // Prefer explicit isEmployee from My Properties. Do not treat owners as
        // employees just because userData.empId happens to be set.
        const isEmployee = props.isEmployee != null
            ? !!props.isEmployee
            : !!(props.empId || props?.employeeData?.empId || props?.employeeData?.EmpId);

        // GeoParking internal user (Owner & Property Management / Pending Approval).
        const isSalesperson = !!(props.isSalespersonloggedin || props.verifiedBy);

        const isRegisteredEmployee =
            isEmployee &&
            (props?.employeeData?.empId || props?.employeeData?.EmpId || props?.userData?.userId || props?.userData?.empId);

        const isVerifiedEmployee =
            isRegisteredEmployee &&
            (
                props?.employeeData?.isEmailPhoneVerified ||
                (props?.employeeData?.isEmailVerified && props?.employeeData?.isPhoneVerified) ||
                props?.userData?.isEmailPhoneVerified ||
                (props?.userData?.isEmailVerified && props?.userData?.isPhoneVerified)
            );


        const finalStatus = resolvePropertyStatus({
            property: props.parkinglotObj,
            isConfirm: true,
            isEmployee,
            isVerifiedEmployee,
            isSalesperson,
        });
        const { VerifyStatus: finalVerifyStatus, ApprovedBy: finalApprovedBy, Comment: finalComment } = getApprovalMetadata(
            props.parkinglotObj,
            props.verifiedBy,
            { finalStatus, isEmployee, isSalesperson }
        );

        let createdBy;
        if (props.checkReviewTab) {
            createdBy = { firstName: props?.parkinglotObj?.createdBy || props?.parkinglotObj?.CreatedBy };
        } else if (props?.employeeData) {
            createdBy = await fetchEmpDetails(props.employeeData.empRegistrationID);
        } else if (props?.userData?.entityRegistrationID) {
            createdBy = await fetchUserDetails(props?.userData?.entityRegistrationID);
        }

        const creatorFullName = [
            createdBy?.firstName || props?.employeeData?.firstName || props?.userData?.firstName,
            createdBy?.lastName || props?.employeeData?.lastName || props?.userData?.lastName
        ].filter(Boolean).join(' ').trim();

        const email1 = {
            EmailId,
            StreetName: streetName,
            EntityRegistrationID: props?.entityId || "",
            EmpRegistrationID:
                props?.parkinglotObj?.empRegistrationId ||
                props?.parkinglotObj?.empRegistrationID ||
                props?.parkinglotObj?.EmpRegistrationID ||
                props?.empRegistrationId ||
                props?.empRegistrationID ||
                props?.EmpRegistrationID ||
                props?.userData?.empRegistrationID ||
                props?.userData?.EmpRegistrationID ||
                props?.userData?.empRegistrationId ||
                props?.employeeData?.empRegistrationID ||
                props?.employeeData?.EmpRegistrationID ||
                "",
            ParkingLotAddress: searchedLocation,
            EmpId: isEmployee
                ? (props?.parkinglotObj?.empId || props?.parkinglotObj?.EmpId || props.empId || props?.employeeData?.empId || props?.employeeData?.EmpId || props?.userData?.empId || props?.userData?.EmpId || 0)
                : (props?.parkinglotObj?.empId || props?.parkinglotObj?.EmpId || 0),
            CreatedBy: props?.parkinglotObj?.createdBy || props?.parkinglotObj?.CreatedBy || props?.verifiedBy || props?.verifiedby || creatorFullName || props?.parkinglotObj?.approvedBy,
            ApprovedBy: finalApprovedBy || props?.parkinglotObj?.approvedBy || props?.parkinglotObj?.ApprovedBy || "NA",
            Comment: finalComment,
            VerifyStatus: finalVerifyStatus,
            CoardinateDetails,
            isParkingSpaceSelected: props.onlyPark,
            City,
            State,
            Zipcode: ZipCode,
            PricingPlanID: 2,
            BankDetailID: SelectedBankDetailID || 0,
            NickName: props.PropertyNickName,
            Region: region,
            MaxRoboTaxiSpots: props?.roboTaxiLimit,
            isRoboTaxiSelected: props?.RoboTaxis,
            groupSchedules,
            robotaxiSelectedGroupNames: props.robotaxiSelectedGroupNames,
            roboTaxiSpotsName: props.roboTaxiSpotsName,
            Status: finalStatus
        };


        const navigateAfterResponse = (response) => {
            if (response?.data) {
                if (myworklistredirect) {
                    navigate("/reviewtab");
                    setLoader(false);
                    return;
                }

                const employeeRegId =
                    props?.empRegistrationId ||
                    props?.empRegistrationID ||
                    props?.EmpRegistrationID ||
                    props?.userData?.empRegistrationID ||
                    props?.userData?.EmpRegistrationID ||
                    props?.userData?.empRegistrationId ||
                    props?.employeeData?.empRegistrationID ||
                    props?.employeeData?.EmpRegistrationID ||
                    null;
                const employeeEmpId =
                    props?.userData?.empId ||
                    props?.userData?.EmpId ||
                    props?.employeeData?.empId ||
                    null;

                // Fast path: stay in-app, no full page reload
                if (typeof props.onPropertySaveSuccess === 'function') {
                    props.onPropertySaveSuccess({
                        ownerId: props.entityId,
                        empRegistrationID: employeeRegId,
                        empId: employeeEmpId,
                        showTeamMembers: Boolean(employeeRegId),
                    });
                    setLoader(false);
                    return;
                }

                // Salesperson flows (Owner Details edit) return to Owner Registration Dashboard.
                // Owners/employees confirming from My Properties must return to that list —
                // not OwnerRegistrationDashboard (which shows Unauthorized for them).
                if (props.isSalespersonloggedin || props.verifiedBy) {
                    navigate(`/OwnerRegistrationDashboard/${props.userData?.firstName || 'owner'}`, {
                        state: {
                            ownerId: props.entityId,
                            ...(employeeRegId
                                ? {
                                    showTeamMembers: true,
                                    empRegistrationID: employeeRegId,
                                    empId: employeeEmpId,
                                }
                                : {}),
                        },
                        replace: true,
                    });
                } else {
                    navigate("/viewparkinginfo", { replace: true });
                }
                setLoader(false);
            }
        };

        axios.post(
            props.parkinglotObj || parkinglotId?.parkingLotId
                ? `${hostPath}/api/UpdateParkingLotDetails`
                : `${hostPath}/api/ParkingLotBooking`,
            {
                ...email1,
                Parking_Lot_ID: props.parkinglotObj?.parking_Lot_ID || parkinglotId?.parkingLotId,
                id: props.parkinglotObj?.id || parkinglotId?.id,
                CreatedDate: props.parkinglotObj?.createdDate || parkinglotId?.createdDate,
                Status: finalStatus
            },
            { headers: { "x-functions-key": hostHeader } }
        )
            .then((response) => {
                if (response?.data && !parkinglotId) {
                    setParkinglotId(response.data);
                }
                navigateAfterResponse(response);
                setLoader(false);
                // window.location.reload();
            })
            .catch((error) => {
                console.error("Error:", error);
                setLoader(false);
            });
    };

const handleShouldapprove = (val1, val2) => {
        setPopupVisible(val2);
    }
    return (
        <div className="col-md-12 ">
            <div class="row m-4">
                <div className="col-lg-12 col-md-12 col-sm-12" style={{ textAlign: "left" }}>
                    <div><b>Review Marked Areas</b></div>
                    <div>Take a close look at the areas you've marked on the map to ensure they accurately reflect your intended designations.</div>
                </div>
            </div>
            <div class="row m-4"  >

                <div id="reviewAndConfirm" style={{}}>
                    <div class="row" style={{ textAlign: "left" }}>
                        <div class="col-lg-4 col-md-4 col-sm-12">
                            <div> <b>Street Address : {searchedLocation}</b></div>
                        </div>
                    </div>
                    <div class="row "  >
                        <div class="col-lg-12 col-md-12 col-sm-12  m-3">
                            <div>
                                <div id="myMap" style={{ height: '750px', width: '100%', margin: '0% 0% 1% -1%' }}></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {loader && (
                <div className="loader-overlay">
                    <FadeLoader />
                </div>
            )}
            {isSalespersonloggedin ? (
                <>
                    <div className=" mb-3" style={{ textAlign: "end", position: "relative" }}>
                        <button
                            type="button"
                            className='icon-btn'
                            onClick={backButtonClick}
                            style={{ marginRight: "10px", position: "relative", right: "65px", bottom: "217px" }}>
                            <MdArrowBackIosNew size={24} style={{ marginLeft: '-9px' }} title="Backward" />
                        </button>
                        <button
                            type="button"
                            className='icon-btn'
                            onClick={handleButtonClick}
                            style={{
                                marginRight: "10px", position: "relative", right: "70px", bottom: "217px", width: "80px", background: "#3f8ed7",
                                color: "white", fontWeight: "bold"
                            }}>
                            Save
                        </button>
                      {isDenyFlow ? (
    <button
        type="button"
        className='icon-btn-finish'
        onClick={() => handleShouldapprove(true, true)}   // ✅ FIXED
        style={{
            marginRight: "10px",
            position: "relative",
            right: "75px",
            bottom: "217px",
            backgroundColor: "red",
            color: "white"
        }}>
        Deny
    </button>
) : (
    <button
        type="button"
        className='icon-btn-finish'
        onClick={() => handleShouldapprove(true, true)}
        style={{
            marginRight: "10px",
            position: "relative",
            right: "75px",
            bottom: "217px"
        }}>
        Verify
    </button>
)}
                    </div>
                </>
            ) : (
                <div className=" mb-3" style={{ textAlign: "end", position: "relative" }}>

                    <button type="submit" className='finishbtn' onClick={backButtonClick} style={{ marginRight: "10px", position: "relative", right: "80px", bottom: "217px" }}>Go Back</button>
                    <button type="submit" className='nextBtn' onClick={handleButtonClick} disabled={isButtonDisabled} style={{ marginRight: "10px", position: "relative", right: "76px", bottom: "217px" }}>
                        {props.verificationstatus ? 'Save' : 'Confirm'}
                    </button>
                    <ToastContainer />

                </div>
            )}
            {isPopupVisible && (
                <VerifyAlert handleShouldapprove={handleShouldapprove} isPopupVisible={isPopupVisible} BankDetails={BankDetails} Scheduleavailability={Scheduleavailability} CoardinateDetails={CoardinateDetails}
                    parkinglotObj={props.parkinglotObj} searchedLocation={searchedLocation} streetName={streetName} entityId={props.entityId} verifiedby={props.verifiedBy} isDenyFlow={isDenyFlow}
                />
            )}
        </div>
    )
}
export default ReviewAndConfirm;